import { useContext } from "react";
import { PrivateNotesContext } from "../contexts/PrivateNotesContext";

/**
 * プライベートメモ管理フック
 * LocalStorageベースで、サーバーには一切送信されない
 */
export const usePrivateNotes = () => {
  const context = useContext(PrivateNotesContext);

  if (!context) {
    throw new Error("usePrivateNotes must be used within PrivateNotesProvider");
  }

  return context;
};
